import type { OrderStatus } from "./types";

export const STATUS_LABELS: Record<OrderStatus, string> = {
  new: "新規",
  confirmed: "確認済み",
  ready: "準備完了",
  picked_up: "お渡し済み",
  cancelled: "キャンセル",
};

export const SOURCE_LABELS: Record<string, string> = {
  instagram_profile: "Instagramプロフィール",
  instagram_story: "Instagramストーリー",
  instagram_dm: "Instagram DM",
  line: "LINE",
  direct: "直接",
};

export function yen(value: number): string {
  return new Intl.NumberFormat("ja-JP", { style: "currency", currency: "JPY", maximumFractionDigits: 0 }).format(value);
}

export function dateLabel(value: string, long = false): string {
  const date = new Date(`${value}T00:00:00+09:00`);
  return new Intl.DateTimeFormat("ja-JP", {
    timeZone: "Asia/Tokyo",
    month: long ? "long" : "numeric",
    day: "numeric",
    weekday: "short",
    ...(long ? { year: "numeric" } : {}),
  }).format(date);
}

export function todayJst(): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date());
}

export function clientUuid(): string {
  const webCrypto = globalThis.crypto;
  if (typeof webCrypto?.randomUUID === "function") return webCrypto.randomUUID();
  const bytes = new Uint8Array(16);
  if (typeof webCrypto?.getRandomValues === "function") webCrypto.getRandomValues(bytes);
  else for (let index = 0; index < bytes.length; index += 1) bytes[index] = Math.floor(Math.random() * 256);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0"));
  return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex.slice(6, 8).join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10).join("")}`;
}

export function itemsLabel(items: Array<{ product_name: string; quantity: number }>): string {
  return items.map((item) => `${item.product_name.replace("（サンプル）", "")} × ${item.quantity}`).join(" / ");
}

export function phoneDisplay(value: string): string {
  if (/^0\d{10}$/.test(value)) return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7)}`;
  if (/^0\d{9}$/.test(value)) return `${value.slice(0, 2)}-${value.slice(2, 6)}-${value.slice(6)}`;
  return value;
}

export function sourceFromLocation(): string {
  const source = new URLSearchParams(window.location.search).get("source") ?? "direct";
  return ["instagram_profile", "instagram_story", "instagram_dm", "line"].includes(source) ? source : "direct";
}

export function urlBase64ToArrayBuffer(base64String: string): ArrayBuffer {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((character) => character.charCodeAt(0))).buffer;
}
